import { Connection } from "@zapier/client";
import type { ConnectionShareType } from "../../types";
import { Key } from "@zapier/design-system";
interface Props {
  connection: Connection;
}

export interface ConnectionShare {
  email?: string | null;
  id: Key;
  memberCount?: number | null;
  name?: string | null;
  photoUrl?: string | null;
  shareType: ConnectionShareType;
}

export default function useFormatConnectionShares({ connection }: Props) {
  // Normalize owner, groups and members to a share object
  const owner = connection?.owner
    ? {
        email: connection?.owner?.email,
        id: connection?.owner?.id,
        name: connection?.owner?.fullName,
        photoUrl: connection?.owner?.photoUrl,
        shareType: "owner" as const,
      }
    : undefined;
  const groups = connection?.groups
    ? connection?.groups?.map(({ id, memberCount, name, photoUrl }) => ({
        id,
        memberCount,
        name,
        photoUrl,
        shareType: id === "all" ? "all" : "group",
      }))
    : [];
  const members = connection?.members
    ? connection?.members?.map(({ id, email, fullName, photoUrl }) => ({
        email,
        id,
        name: fullName,
        photoUrl,
        shareType: "member",
      }))
    : [];

  return {
    formattedConnectionShares: [
      ...(owner ? [owner] : []),
      ...groups,
      ...members,
    ] as ConnectionShare[],
  };
}
